import styled, { createGlobalStyle } from 'styled-components';
import { fonts, colors, typography, spacing } from '@izettle/otto';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';

const fallbacks = fonts.zen.fallbacks.join(", ");
const GlobalStyle = createGlobalStyle`
  a {
    color: ${colors.action.inline.text.default};
    text-decoration: none;
  }

  body {
    font-family: ${fonts.zen.name}, ${fallbacks};
    ${typography.regular};
  }

  div, ul, ol, li, h1, h2, h3, h4, h5, h6, pre, code, form, fieldset, input, button, textarea, select, p, blockquote {
    margin: 0;
    padding: 0;
  }

  /* #root for react-spa, #storybook-root for storybook */
  #root *, #storybook-root * {
    box-sizing: border-box;

    /* Needs to be set explicitly for pseudo-elements */
    &:before,
    &:after {
      box-sizing: border-box;
    }
  }
`;
const VerticalNavWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__VerticalNavWrapper",
  componentId: "zettle__sc-1mx89mj-0"
})(["position:relative;width:100%;display:flex;flex-direction:column;overflow:auto;z-index:0;padding:", " ", " 0;@media (min-width:1200px){padding:", " ", " 0;}@media (min-width:1520px){padding:", " ", " 0;}@media print{overflow:visible;}"], spacing.large, spacing.small, spacing.xLarge, spacing.xLarge, spacing.xLarge, spacing.xxLarge);
const VerticalNavAppContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__VerticalNavAppContainer",
  componentId: "zettle__sc-1mx89mj-1"
})(["max-width:1340px;"]);
const AppContainer = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/jsx(VerticalNavWrapper, {
    children: /*#__PURE__*/jsx(VerticalNavAppContainer, {
      children: children
    })
  });
};
const DefaultRootStyle = createGlobalStyle`
  #root, #storybook-root {
    display: flex;
    flex-direction: column;

    @media (min-width: 1280px) {
      flex-direction: row;
    }
  }
`;
const PaypalHeaderRootStyle = createGlobalStyle`
  #root, #storybook-root {
    @media (min-width: 1280px) {
      display: grid;
      grid-template-columns: auto 1fr;
      grid-template-rows: auto auto;
      grid-template-areas:
        "ppheader ppheader"
        "vn content";

      /* stylelint-disable-next-line */
      pp-profile-widget {
        grid-area: ppheader;
      }

      /* stylelint-disable-next-line */
      iz-bo-vertical-navigation {
        grid-area: vn;
      }

      .main-content-outer-wrapper {
        grid-area: content;
      }
    }
  }
`;
const getRootStyle = _ref2 => {
  let {
    paypalWidgetVisible
  } = _ref2;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(DefaultRootStyle, {}), paypalWidgetVisible && /*#__PURE__*/jsx(PaypalHeaderRootStyle, {})]
  });
};
const UnsupportedBrowserStyles = createGlobalStyle`
/* stylelint-disable-next-line selector-type-no-unknown */
  iz-bo-unsupported-browser {
    display: block;
    margin: 0 0 ${spacing.large} 0;

    &:not(:defined) {
      margin: 0;
    }
  }
`;

export { AppContainer, DefaultRootStyle, GlobalStyle, PaypalHeaderRootStyle, UnsupportedBrowserStyles, getRootStyle };
//# sourceMappingURL=styles.js.map
